import {
    Grid,
} from '@mui/material'

import Card from 'app/shared-components/Card'
import TextSingleline from 'app/shared-components/TextSingleline'
import Switch from 'app/shared-components/Switch'
import ContactsContainer from 'app/Apps/ContactManagement/ContactsLinked/ContactsContainer'
import useLabel from 'app/hooks/useLabel'
import {
    LocationType,
    RegionZeroLevel,
    RegionFirstLevel,
    RegionSecondLevel,
} from 'app/enums/label.enums'
import useEnumValues from 'app/hooks/useEnumValues'
import StatusHandler from 'app/shared-components/StatusHandler'

import {
    useGetLocation,
} from '../hooks'

import useStyles from './LocationOverview.styles'

type Props = {
    id: string | number,
}

const LocationOverview = ({
    id,
}: Props) => {
    const {
        data,
        isDataReady,
        isFetching,
        isError,
        error,
    } = useGetLocation(id)

    const {
        classes,
    } = useStyles()
    const l = useLabel()

    const allowedLocationTypes = useEnumValues()(LocationType)
    const regionZeroLabels = useEnumValues()(RegionZeroLevel)
    const regionFirstLabels = useEnumValues()(RegionFirstLevel)
    const regionSecondLabels = useEnumValues()(RegionSecondLevel)

    return (
        <StatusHandler
            isSuccess={isDataReady}
            isFetching={isFetching}
            isError={isError}
            error={error}
        >
            <div className={classes.container}>
                <Grid
                    container
                    spacing={2}
                >
                    <Grid
                        size={{
                            xs: 12,
                        }}
                    >
                        <Card
                            title="Location"
                        >
                            <Grid
                                container
                                spacing={2}
                            >
                                <Grid
                                    size={{
                                        xs: 12, sm: 6,
                                    }}
                                >
                                    <TextSingleline
                                        title={l('PreConUnit.locationLocationName')}
                                        value={data?.locationName}
                                    />
                                    <TextSingleline
                                        title={l('OrderLocationView.locationType')}
                                        value={allowedLocationTypes?.[data?.locationType]}
                                    />
                                    <Switch
                                        title="Is Shipping Location"
                                        value={data?.isShippingLocation}
                                        disabled
                                    />
                                </Grid>
                                <Grid
                                    size={{
                                        xs: 12, sm: 3,
                                    }}
                                >
                                    <TextSingleline
                                        title={l('Country.regionZeroLevel')}
                                        value={regionZeroLabels[
                                            data?.regionZeroLevel
                                        ]}
                                    />
                                    <TextSingleline
                                        title={l('Country.regionFirstLevel')}
                                        value={regionFirstLabels[
                                            data?.regionFirstLevel
                                        ]}
                                    />
                                    <TextSingleline
                                        title={l('Country.regionSecondLevel')}
                                        value={regionSecondLabels[
                                            data?.regionSecondLevel
                                        ]}
                                    />
                                </Grid>
                            </Grid>
                        </Card>
                    </Grid>
                    <ContactsContainer
                        isWrapped
                        value={data?.id}
                    />
                </Grid>
            </div>

        </StatusHandler>
    )
}

export default LocationOverview
